import { useContext, useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { ThemeContext } from '../../../context/theme-context';
import SaleDetailView from '../../../Components/Vendas/ListaVendas/SaleDetailView';
import { IVendas } from '../../../Components/Vendas/ListaVendas/interfaces/IVendas';
import { showSale } from '../../../Services/sales-service';
import { notifyError } from '../../../Components/notify/notify-component';
import Globals from '../../../Globals.json';

export default function CadVendaDetalhe() {
  const { collapsed } = useContext(ThemeContext);
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const location = useLocation<{ venda?: IVendas }>();

  const [venda, setVenda] = useState<IVendas | undefined>(location.state?.venda);
  const [loading, setLoading] = useState<boolean>(!location.state?.venda);

  useEffect(() => {
    if (location.state?.venda) {
      return;
    }

    setLoading(true);
    showSale(id)
      .then((response) => {
        setVenda(response.data?.data ?? response.data);
      })
      .catch((error) => {
        notifyError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id, location.state]);

  const handleBack = () => {
    history.push(Globals.paths.CadVendas);
  };

  return (
    <Container
      className={collapsed ? 'contenteLayoutCollapsed' : 'contenteLayout'}
    >
      <SaleDetailView venda={venda} onBack={handleBack} loading={loading} />
    </Container>
  );
}
